import { getToken } from "src/utils/authUtils";
import CryptoJS from 'crypto-js';


let BASE_URL = process.env.REACT_APP_API_URL

export async function loadConfig() {
  try {
    const res = await fetch(`${process.env.PUBLIC_URL}/config.enc.json`, { cache: 'no-store' });
    const { iv, data } = await res.json();

    const key = CryptoJS.SHA256("my-strong-secret");
    const decrypted = CryptoJS.AES.decrypt(data, key, {
      iv: CryptoJS.enc.Base64.parse(iv),
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });

    const configText = decrypted.toString(CryptoJS.enc.Utf8);
    const config = JSON.parse(configText);

    BASE_URL = config.API_URL || BASE_URL;
  } catch (error) {
    console.error("❌ Failed to load encrypted config. Using .env fallback", error);
  }
}

/*
loadConfig().then(() => {
});
*/

async function getCsrfToken() {
  const response = await fetch(`${BASE_URL}/csrf/token`, { method: "GET", credentials: "include" });
  const data = await response.json();
  return data.csrfToken;
}

export async function createQuestion(body:any) {
    try{

    const token = getToken();
    //const csrfToken = await getCsrfToken();

     const headers = {
         "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        // "X-CSRF-TOKEN": csrfToken,
     };
     const response = await fetch(`${BASE_URL}/bank-questions`, {
         method: "POST",
         headers,
         body: JSON.stringify(body),
        //  credentials: "include",
     });


     const data = await response.json();
     if (!response.ok || !data.success) {
         if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
             throw new Error("Forbidden: You do not have permission to access this resource.");
         }
         //console.log("Failed to fetch");
     }
     return data;
 } catch (error: any) {
     //console.log(error);
 }
}

// Function to handle fetch requests
export async function fetchAllDataApi( options: RequestInit = {}): Promise<any> {

    const token = getToken();
    //const csrfToken = await getCsrfToken();
  
  
    const headers = {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      // "X-CSRF-TOKEN": csrfToken,
    };
    try {
      const response = await fetch(`${BASE_URL}/bank-questions`, {
        ...options,
        headers,
        // credentials: "include"
      });
  
      const data = await response.json();
  
      if (!response.ok ) {
        if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
          throw new Error("Forbidden: You do not have permission to access this resource.");
        }
        //console.log("Failed to fetch");
      }
      return data;
    } catch (error: any) {
    
    }
  }

// Function to handle fetch requests
export async function fetchDataApi(url: string, options: RequestInit = {}): Promise<any> {

    const token = getToken();
    console.log(token)
     //const csrfToken = await getCsrfToken();
  
    const headers = {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      //  "X-CSRF-TOKEN": csrfToken,
    };
    try {
      const response = await fetch(`${BASE_URL}/${url}`, {
        ...options,
        headers,
        // credentials: "include"
      });
  
      const data = await response.json();
  
      if (!response.ok || !data.success) {
        if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
          throw new Error("Forbidden: You do not have permission to access this resource.");
        }
        //console.log("Failed to fetch");
      }
      return data;
    } catch (error: any) {
     
    }
  }




  export async function createSurvey(body:any) {
    try{
    const token = getToken();
    //const csrfToken = await getCsrfToken();

     const headers = {
         "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        //  "X-CSRF-TOKEN": csrfToken,
     };
     const response = await fetch(`${BASE_URL}/publicSurvey`, {
         method: "POST",
         headers,
         body: JSON.stringify(body),
        //  credentials: "include",
     });

     


     const data = await response.json();
     if (!response.ok || !data.success) {
         if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
             throw new Error("Forbidden: You do not have permission to access this resource.");
         }
         //console.log("Failed to fetch");
     }
     return data;
 } catch (error: any) {
     //console.log(error);
 }
}



export async function deleteSurveyApi(id: string): Promise<void> {
  try {
    const token = getToken();
    //const csrfToken = await getCsrfToken();
    const response = await fetch(`${BASE_URL}/publicSurvey/${id}`, {
      // credentials: "include",
       method: 'DELETE',

      headers: {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        // "X-CSRF-TOKEN": csrfToken,

      },
    });

    const data = await response.json();
    if (!response.ok ) {
        if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
            throw new Error("Forbidden: You do not have permission to access this resource.");
        }
        throw new Error("Failed to fetch");
    }
    return data;
} catch (error: any) {
    throw new Error(error);
}
}
  

export async function deleteQuestionApi(id: string): Promise<void> {
  try {
    const token = getToken();
    //const csrfToken = await getCsrfToken();
    const response = await fetch(`${BASE_URL}/bank-questions/${id}`, {
      // credentials: "include" ,
      method: 'DELETE',

      headers: {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        // "X-CSRF-TOKEN": csrfToken,

      },
    });
    const data = await response.json();
    if (!response.ok ) {
        if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
            throw new Error("Forbidden: You do not have permission to access this resource.");
        }
        throw new Error("Failed to fetch");
    }
    return data;
} catch (error: any) {
    throw new Error(error);
}
}

export async function getSurveyQuestionByQuarter(riskId: any, quarter: string,year:number): Promise<any> {
    try {
      const token = getToken();
      //const csrfToken = await getCsrfToken();
      const response = await fetch(`${BASE_URL}/survey-assessment/oneQuestion/${riskId}/quarter/${quarter}/year/${year}`, {
        method: 'GET',
        headers: {

          'Content-Type': 'application/json',
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
          // 'X-CSRF-TOKEN': csrfToken,
        },
        // credentials: "include",

      });
  
      const data = await response.json();
      if (!response.ok || !data.success) {
        if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
          throw new Error("Forbidden: You do not have permission to access this resource.");
        }
        //console.log("Failed to fetch");
      }
      return data;
    } catch (error: any) {
      //console.log(error);
    }
  
}

export async function getSurveyQuestionByQuarterByPage(riskId: any,vendorId:any, quarter: string,year:number,page:number,size:number): Promise<any> {
  try {
    const token = getToken();
    //const csrfToken = await getCsrfToken();
    const response = await fetch(`${BASE_URL}/survey-assessment/${riskId}/${vendorId}/quarter/${quarter}/year/${year}/page/${page}/size/${size}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',

        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        // 'X-CSRF-TOKEN': csrfToken,
      },
      // credentials: "include",

    });

    const data = await response.json();
    if (!response.ok || !data.success) {
      if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
        throw new Error("Forbidden: You do not have permission to access this resource.");
      }
      //console.log("Failed to fetch");
    }
    return data;
  } catch (error: any) {
    //console.log(error);
  }

}


export async function assesstQuestion(body: any): Promise<any> {
  try {
    const token = getToken();
    //const csrfToken = await getCsrfToken();
    const response = await fetch(`${BASE_URL}/survey-assessment`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        // 'X-CSRF-TOKEN': csrfToken,
      },
      body: JSON.stringify(body),
      // credentials: "include",

    });

      const data = await response.json();
      if (!response.ok || !data.success) {
          if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
              throw new Error("Forbidden: You do not have permission to access this resource.");
          }
          //console.log("Failed to fetch");
      }
      return data;
  } catch (error: any) {
   
  }
}

export async function getRCSAByPage( quarter: string, year: number, page: number, pageSize: number): Promise<any> {
  try {
    const token = getToken();
    //const csrfToken = await getCsrfToken();
    const response = await fetch(`${BASE_URL}/survey-assessment/compliance-data/quarter/${quarter}/year/${year}/page/${page}/size/${pageSize}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        // 'X-CSRF-TOKEN': csrfToken,

      },
      // credentials: "include",
    });
    const data = await response.json();
    if (!response.ok ) {
        if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
            throw new Error("Forbidden: You do not have permission to access this resource.");
        }
        throw new Error("Failed to fetch");
    }
    return data;
} catch (error: any) {
    throw new Error(error);
}
}

export async function updateSurveyApi(id: any, body: any): Promise<void> {
  try {
    const token = getToken();
    //const csrfToken = await getCsrfToken();
    const fullUrl = `${BASE_URL}/publicSurvey/${id}`; // Construct the full URL
   
    const response = await fetch(fullUrl, {
      // credentials: "include",
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        // 'X-CSRF-TOKEN': csrfToken,
      },
      body: JSON.stringify(body),

    });

    const data = await response.json();
    //console.log("Update API Response:", data); // Log the response

    if (!response.ok || !data.success) {
      if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
        throw new Error("Forbidden: You do not have permission to access this resource.");
      }
    
    }

    return data; // Return the response data
  } catch (error) {
    
  }
}



export async function uploadExcelForRCSA(file: File) {
  const token = getToken();
  //const csrfToken = await getCsrfToken();
  try {
      const formData = new FormData();
      formData.append('file', file);


      // Do not set 'Content-Type' when using FormData
      const headers = {
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        // 'X-CSRF-TOKEN': csrfToken,
      };


      const response = await fetch(`${BASE_URL}/survey-assessment/excel`, {
          method: "POST",
          body: formData,
          headers,
          // credentials: "include",
      });

      const data = await response.json();
      if (!response.ok ) {
          if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
              throw new Error("Forbidden: You do not have permission to access this resource.");
          }
          throw new Error("Failed to fetch");
      }
      return data;
  } catch (error: any) {
      throw new Error(error);
  }
}




export async function uploadExcelForRiskProfile(file: File) {
  const token = getToken();
  //const csrfToken = await getCsrfToken();
  try {
      const formData = new FormData();
      formData.append('file', file);


      // Do not set 'Content-Type' when using FormData
      const headers = {
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        // 'X-CSRF-TOKEN': csrfToken,
      };


      const response = await fetch(`${BASE_URL}/survey-assessment/excelForRiskProfile`, {
          method: "POST",
          body: formData,
          headers,
          // credentials: "include",
      });


      const data = await response.json();
      if (!response.ok ) {
          if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
              throw new Error("Forbidden: You do not have permission to access this resource.");
          }
          throw new Error("Failed to fetch");
      }
      return data;
  } catch (error: any) {
      throw new Error(error);
  }
}


export async function fetchOneSurveyApi(url: string, options: RequestInit = {}): Promise<any> {
  try {
    const token = getToken();
    //const csrfToken = await getCsrfToken();
    const headers = {
      "Content-Type": "application/json",

      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      // 'X-CSRF-TOKEN': csrfToken,
    };


    const fullUrl = `${BASE_URL}/${url}`; // Construct the full URL
    //console.log("Fetching from URL:", fullUrl); // Log the URL

    const response = await fetch(fullUrl, {
      ...options,
      headers,
      // credentials: "include",
    });

    const data = await response.json();
    //console.log("API Response:", data); // Log the response

    if (!response.ok || !data.success) {
      if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
        throw new Error("Forbidden: You do not have permission to access this resource.");
      }
      //console.log("Failed to fetch");
    }
    return data;
  } catch (error: any) {

   //console.error("Error in fetchOneApi:", error); // Log the error
    //console.log(error);
  }
}


export const updateQuestionApi = async (id: string, data: any) => {
  try {
    const token = getToken();
    //const csrfToken = await getCsrfToken();
    const response = await fetch(`${BASE_URL}/bank-questions/${id}`, {
      method: 'PATCH',
      headers: {

        'Content-Type': 'application/json',
        Authorization: `Bearer ${getToken()}`,
        // 'X-CSRF-TOKEN': csrfToken,
      },
      body: JSON.stringify(data),
      // credentials: "include",
    });

    const result = await response.json();
    if (!response.ok ) {
        if (response.status === 401 || response.status === 403 || result.message === "Forbidden access") {
            throw new Error("Forbidden: You do not have permission to access this resource.");
        }
        throw new Error("Failed to fetch");
    }
    return result;
} catch (error: any) {
    throw new Error(error);
}
};



export async function fetchOneQuestionApi(url: string, options: RequestInit = {}): Promise<any> {
  try {
    const token = getToken();
    //const csrfToken = await getCsrfToken();
    const headers = {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      // 'X-CSRF-TOKEN': csrfToken,
    };

    const fullUrl = `${BASE_URL}/${url}`; // Construct the full URL
    //console.log("Fetching from URL:", fullUrl); // Log the URL

    const response = await fetch(fullUrl, {
      ...options,
      headers,
      // credentials: "include",
    });

    const data = await response.json();
    //console.log("API Response:", data); // Log the response

    if (!response.ok || !data.success) {
      if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
        throw new Error("Forbidden: You do not have permission to access this resource.");
      }
      //console.log("Failed to fetch");
    }

    return data;
  } catch (error: any) {
    //console.error("Error in fetchOneApi:", error); // Log the error
    //console.log(error);
  }
}


export const fetchQuestionByReference = async (id: string) => {
  try {
    const token = getToken();
    //const csrfToken = await getCsrfToken();
    
    const response = await fetch(`${BASE_URL}/bank-questions/by-reference?referenceId=${id}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        // 'X-CSRF-TOKEN': csrfToken,
      },
      // credentials: "include",
    });

    const data = await response.json();
    if (!response.ok ) {
        if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
            throw new Error("Forbidden: You do not have permission to access this resource.");
        }
        throw new Error("Failed to fetch");
    }
    return data;
} catch (error: any) {
    throw new Error(error);
}
};




export async function fetchAllVendors( options: RequestInit = {}): Promise<any> {

    const token = getToken();
    
    const headers = {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    
    };
    try {
      const response = await fetch(`${BASE_URL}/vendors`, {
      method: 'GET',
        ...options,
        headers,
      
      });
  
      const data = await response.json();
  
      return data;
    } catch (error: any) {
     
    }
  }



  export const inviteVendorApi = async (data: {
    name: string;
    email: string;
    publicSurveyId: string;
  }) => {
    const response = await fetch(`${BASE_URL}/vendors/invite`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
      body: JSON.stringify(data)
    });
    return await response.json();
  };